import styled from 'styled-components';
import { maxMediaQueries } from '@finect/tabular-utils/mediaQueries';
import { Card } from './Card';

export const CardRow = styled(Card)`
  justify-content: space-between;
  min-height: 96px;
  padding-left: 9px;
  padding-right: 9px;

  color: ${({ theme }) => theme.colors.font};

  ${maxMediaQueries.tablet`
    flex-direction: column;
  `};

  ${maxMediaQueries.phablet`
    padding-left: 9px;
    padding-right: 9px;
  `};

  ${maxMediaQueries.phone`
    padding: 15px;
  `};

  > span:first-of-type {
    position: absolute;
    top: 15px;
    left: 9px;

    ${maxMediaQueries.phone`
      top: 15px;
      left: 15px;
    `};
  }

  small {
    display: ${({ adviser }) => (adviser ? 'inline-block' : 'block')};

    &:first-child {
      ${({ adviser }) => (adviser ? 'display: block' : null)};
    }
  }
`;
